module.exports = __webpack_public_path__ + "img/Bild_home.15a62992.jpeg";